import util   from '../../common/AppUtil';

const ServerMode = 0;
const ApiCode = "XLog";

export default {
  
  execute: function(action,params) {
    return util.callServerPost(ServerMode,ApiCode,params,action);
  }
}
  


// WEBPACK FOOTER //
// ./src/api/system/xlog.js